export const NAVBAR_HEIGHT = 56; // px
export const FOOTER_HEIGHT = 56; // px

export const PADDING_CONTAINER = 0; // px

export const BREAKPOINT_VERTICAL = {
    lg: 992,
    md: 768,
    sm: 576,
    xs: 0,
}

export const COLORS = {
    primary: '#007bff',
    secondary: '#6c757d',
    success: '#28a745',
    info: '#17a2b8',
    warning: '#ffc107',
    danger: '#dc3545',
    light: '#f8f9fa',
    dark: '#343a40',
    white: '#ffffff',
    black: '#000000',
    bgContainer: '#efefef',
    bgContainerDark: '#343a40',
};
